import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import { get } from 'lodash';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
const P = AntragSchema.attributes;

const WissenschaftlicheEffekteSkizzeLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<ApplicationHeading title={'Wissenschaftliche Effekte'} />
			<Typography>
				<strong>Bitte gehen Sie u.a. auf folgende Bereiche ein: </strong> angestrebte Effekte für die Wissenschaft, nachhaltige Effekte für die
				eingebundenen Hochschulen / Forschungseinrichtungen (Forschung & Lehre, Kooperationen, Publikationen, …).
			</Typography>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default WissenschaftlicheEffekteSkizzeLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Skizze, maxCharLength: 5500, hideLabel: true },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStruc = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucWissenschaftlicheEffekteSkizzeLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const bilderLength = get(application, P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path, []).length;

	//check if there are images, if yes then validate the additional fields for each image
	for (let i = 0; i < bilderLength; i++) {
		//map customFOrmStruc with index to each path
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStruc(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder,
		);
		result = concat(result, customFormStrucWithIndex);
	}

	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt.path,
		)
	) {
		result = concat(result, formStrucPruefAssistenz());
	}
	result = concat(result, getFormStrucWithoutComponentTable(formStruc()));

	return result;
};
